import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Button } from '@cian/button-component';
import * as React from 'react';
import { EActiveView } from '../../types/view';
import { ECreateStatus, EAuthenticateStatus } from '../../types/social';
import { isEmail, isValidPhone } from '../../utils/validation';
import { ViewContainer } from '../../containers/ViewContainer';
import { FormItem } from '../FormItem';
import * as styles from './styles.css';
import { trackSocialCreateShow } from '../../utils/tracking';
export var SocialCreateView = /*#__PURE__*/function (_React$Component) {
  _inherits(SocialCreateView, _React$Component);

  var _super = _createSuper(SocialCreateView);

  function SocialCreateView(props) {
    var _this;

    _classCallCheck(this, SocialCreateView);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleEmailValueChange", function (email) {
      _this.setState({
        email: email,
        isChanged: true,
        isEmailInvalid: !!email && !isEmail(email)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePhoneValueChange", function (phone) {
      _this.setState({
        phone: phone,
        isChanged: true,
        isPhoneInvalid: !!phone && !isValidPhone(phone)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmitClick", function (event) {
      event.preventDefault();
      var _this$state = _this.state,
          email = _this$state.email,
          phone = _this$state.phone;

      if (!email || !isEmail(email) || phone && !isValidPhone(phone)) {
        _this.setState({
          isEmailInvalid: !email || !isEmail(email),
          isPhoneInvalid: !!phone && !isValidPhone(phone)
        });

        return;
      }

      _this.setState({
        isChanged: false,
        isEmailInvalid: false
      });

      _this.props.socialCreate({
        email: email,
        phone: phone
      });
    });

    var _props$social = props.social,
        _email = _props$social.email,
        _phone = _props$social.phone;
    _this.state = {
      email: _email || '',
      phone: _phone || '',
      isChanged: !!props.social.authenticate.error || !!props.social.create.error,
      isEmailInvalid: false,
      isPhoneInvalid: false
    };
    return _this;
  }

  _createClass(SocialCreateView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      trackSocialCreateShow();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$social = this.props.social,
          _this$props$social$au = _this$props$social.authenticate,
          authenticateStatus = _this$props$social$au.status,
          authenticateError = _this$props$social$au.error,
          _this$props$social$cr = _this$props$social.create,
          createStatus = _this$props$social$cr.status,
          createError = _this$props$social$cr.error;
      var _this$state2 = this.state,
          email = _this$state2.email,
          phone = _this$state2.phone,
          isChanged = _this$state2.isChanged,
          isEmailInvalid = _this$state2.isEmailInvalid,
          isPhoneInvalid = _this$state2.isPhoneInvalid;
      var isDisabled = authenticateStatus === EAuthenticateStatus.Loading || createStatus === ECreateStatus.Loading;
      var isError = (createStatus === ECreateStatus.Failed || authenticateStatus === EAuthenticateStatus.Failed && createStatus === ECreateStatus.Succeed) && !isChanged;
      var error = isError ? createStatus === ECreateStatus.Failed ? createError : authenticateError : undefined;
      return /*#__PURE__*/React.createElement(ViewContainer, {
        prevView: EActiveView.AuthenticationRegistration
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles['header']
      }, "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438"), /*#__PURE__*/React.createElement("form", {
        action: "#"
      }, /*#__PURE__*/React.createElement("div", {
        className: styles['email_row']
      }, /*#__PURE__*/React.createElement(FormItem, {
        id: "social_create-email",
        type: "email",
        name: "email",
        label: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
        required: true,
        invalid: isError || isEmailInvalid,
        error: isError ? error : undefined,
        value: email,
        onValueChange: this.handleEmailValueChange,
        disabled: isDisabled
      })), /*#__PURE__*/React.createElement("div", {
        className: styles['phone_row']
      }, /*#__PURE__*/React.createElement(FormItem, {
        id: "social_create-phone",
        name: "phone",
        label: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
        invalid: isError || isPhoneInvalid,
        mask: "+7 (999) 999-99-99",
        value: phone,
        onValueChange: this.handlePhoneValueChange,
        disabled: isDisabled
      })), /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        disabled: !email,
        isSync: isDisabled,
        onClick: this.handleSubmitClick
      }, "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F")));
    }
  }]);

  return SocialCreateView;
}(React.Component);